import React, { useMemo } from 'react';

import {
  adaptProductToRow,
  makeOrderProductsColumns
} from './OrderProductsTableColumns.js';
import useAdvanceTable from '../../../hooks/useAdvanceTable.js';
import AdvanceTable from '../../base/AdvanceTable.js';

import AdvanceTableFooter from '../../base/AdvanceTableFooter.js';
import OrdersProductsTopSection from './OrdersProductsTopSection.js';
import AdvanceTableProvider from '../../../providers/AdvanceTableProvider.js';

const OrderProductsTable = ({
  products = [],
  openPlanModal,
  handleEditProduct,
  handleRemoveProduct,
  toggleFromStock,
  stockAvail = {}
}) => {
  const tableData = useMemo(() => {
    return (products || []).map(adaptProductToRow);
  }, [products]);

  const columns = useMemo(() => {
    return makeOrderProductsColumns({
      openPlanModal,
      handleEditProduct,
      handleRemoveProduct,
      toggleFromStock,
      stockAvail
    });
  }, [openPlanModal, handleEditProduct, handleRemoveProduct, toggleFromStock, stockAvail]);

  const table = useAdvanceTable({
    data: tableData,
    columns,
    pageSize: 6,
    pagination: true,
    sortable: true
  });

  return (
    <AdvanceTableProvider {...table}>
      <OrdersProductsTopSection activeView="list" />

      <div className="border-bottom">
        <AdvanceTable
          tableProps={{
            className: 'phoenix-table border-top border-200 fs-9'
          }}
        />
        <AdvanceTableFooter pagination className="py-3" />
      </div>
    </AdvanceTableProvider>
  );
};

export default OrderProductsTable;
